<div class="flex flex-col flex-auto min-w-0">

    <div *ngIf="userUiType === 4" class="flex flex-col flex-auto">
        <div class="relative flex flex-col flex-0 items-center justify-center p-6 sm:p-10 overflow-hidden bg-gray-50 dark:bg-gray-900">
            <div class="absolute inset-0 bg-gradient-to-br from-blue-500 to-purple-600 opacity-10 dark:opacity-20"></div>
            <div class="relative z-10 flex flex-col items-center w-full max-w-screen-xl mx-auto">
                <div class="flex items-center">
                    <img class="w-40 h-20" ngSrc="assets/images/altitude%20rewards/logo/Ambassador-seal-1.png" alt="Ambassador Seal" width="660" height="320">
                    <div class="ml-6 text-left">
                        <div class="text-4xl font-bold tracking-tight leading-none">
                            Hello, {{user.ds_firstname}}!
                        </div>
                        <div class="mt-1.5 text-lg text-secondary">
                            Let's create something amazing today.
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="flex-auto p-6 sm:p-10">
            <div class="w-full max-w-screen-xl mx-auto">

                <div class="flex flex-col p-8 bg-card shadow rounded-2xl mb-8">
                    <div class="flex items-start">
                        <div class="flex items-center justify-center w-12 h-12 rounded-full bg-blue-100 text-blue-600 dark:bg-blue-900 dark:text-blue-100 mr-6">
                            <mat-icon class="icon-size-6" [svgIcon]="'heroicons_outline:information-circle'"></mat-icon>
                        </div>
                        <div class="flex flex-col">
                            <div class="text-xl font-semibold leading-tight text-primary">Build Your Profile</div>
                            <div class="mt-2 text-secondary text-lg leading-relaxed">
                                The ambassador dashboard is designed to help you curate your profile. Add images, tours, videos, and information about yourself—anything you can add to bring your profile to life!
                            </div>
                            <div class="mt-4 p-4 rounded-lg bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700">
                                <div class="flex items-center">
                                    <mat-icon class="text-indigo-500 icon-size-5 mr-2" [svgIcon]="'heroicons_solid:chart-bar'"></mat-icon>
                                    <span class="font-medium text-primary">Looking for your data?</span>
                                </div>
                                <div class="mt-1 text-secondary">
                                    This site is exclusively for setting up your profile presence. To view detailed metrics, leads, and analytics, please visit the <span class="font-semibold text-indigo-500">Go High Level Partner Portal</span> below.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="isInitializing" class="flex items-center justify-center py-12">
                    <mat-progress-spinner [diameter]="48" [mode]="'indeterminate'"></mat-progress-spinner>
                </div>

                <ng-container *ngIf="!isInitializing">
                    <div class="mt-12">
                        <div class="text-2xl font-semibold tracking-tight">Quick Actions</div>
                        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-6">
                            <button (click)="navigateToManagement('features')" mat-flat-button color="primary" class="h-24 text-lg">
                                <mat-icon class="mr-2" [svgIcon]="'heroicons_outline:puzzle-piece'"></mat-icon>
                                Manage Profile
                            </button>
                            <button (click)="navigateToManagement('addimages')" mat-stroked-button class="h-24 text-lg">
                                <mat-icon class="mr-2" [svgIcon]="'heroicons_outline:photo'"></mat-icon>
                                Add Images
                            </button>
                            <button (click)="navigateToManagement('ambassadorpicks')" mat-stroked-button class="h-24 text-lg">
                                <mat-icon class="mr-2" [svgIcon]="'heroicons_outline:star'"></mat-icon>
                                Manage Picks
                            </button>
                            <button (click)="navigateToManagement('blog')" mat-stroked-button class="h-24 text-lg">
                                <mat-icon class="mr-2" [svgIcon]="'heroicons_outline:pencil-square'"></mat-icon>
                                Create Blog Post
                            </button>
                        </div>
                    </div>

                    <div class="mt-8 mb-4">
                        <a href="https://app.gohighlevel.com/" target="_blank" class="relative group flex flex-col items-center justify-between w-full p-6 overflow-hidden rounded-2xl cursor-pointer shadow-md hover:shadow-xl transition-all duration-300">
                            <div class="absolute inset-0 bg-gradient-to-r from-indigo-600 via-purple-600 to-blue-600 bg-[length:200%_auto] animate-gradient transition-all duration-500 group-hover:bg-right"></div>
                            <div class="absolute inset-0 opacity-0 group-hover:opacity-20 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] transition-opacity duration-300"></div>
                            <div class="relative z-10 flex items-center justify-between w-full">
                                <div class="flex items-center">
                                    <div class="flex items-center justify-center w-14 h-14 rounded-full bg-white/20 backdrop-blur-md border border-white/30 mr-5 shadow-inner">
                                        <mat-icon class="icon-size-8 text-white" [svgIcon]="'heroicons_outline:rocket-launch'"></mat-icon>
                                    </div>
                                    <div class="flex flex-col text-left">
                                        <span class="text-2xl font-bold text-white tracking-wide">Launch Partner Portal</span>
                                        <span class="text-indigo-100 font-medium text-sm mt-1">Access CRM, Leads & Metrics</span>
                                    </div>
                                </div>
                                <div class="flex items-center justify-center w-10 h-10 rounded-full bg-white text-indigo-600 transform transition-transform duration-300 group-hover:translate-x-2 shadow-lg">
                                    <mat-icon class="icon-size-6" [svgIcon]="'heroicons_solid:arrow-right'"></mat-icon>
                                </div>
                            </div>
                        </a>
                    </div>

                    <div *ngIf="showMetrics">
                        <div *ngIf="isLoadingMetrics; else metricsCards" class="flex items-center justify-center h-64">
                            <mat-progress-spinner [diameter]="48" [mode]="'indeterminate'"></mat-progress-spinner>
                        </div>

                        <ng-template #metricsCards>
                            <div *ngIf="ambassadorMetrics" class="flex flex-col gap-6">
                                <div class="grid grid-cols-1 sm:grid-cols-6 gap-6">
                                    <div class="sm:col-span-2 flex flex-col p-6 bg-card shadow rounded-2xl">
                                        <div class="flex items-center">
                                            <mat-icon class="icon-size-8 text-blue-500" [svgIcon]="'heroicons_solid:chart-bar'"></mat-icon>
                                            <div class="ml-4 text-secondary font-medium">Content Views</div>
                                        </div>
                                        <div class="mt-4 text-4xl font-bold">{{ ambassadorMetrics.vi_view_count_4weeks | number }}</div>
                                        <div class="mt-1 text-sm text-secondary">Reach in the last 4 weeks</div>
                                    </div>
                                    <div class="sm:col-span-2 flex flex-col p-6 bg-card shadow rounded-2xl">
                                        <div class="flex items-center">
                                            <mat-icon class="icon-size-8 text-red-500" [svgIcon]="'heroicons_solid:heart'"></mat-icon>
                                            <div class="ml-4 text-secondary font-medium">Community Favorites</div>
                                        </div>
                                        <div class="mt-4 text-4xl font-bold">{{ ambassadorMetrics.vi_favoriteby_count | number }}</div>
                                        <div class="mt-1 text-sm text-secondary">Times you or your picks have been favorited</div>
                                    </div>
                                    <div class="sm:col-span-2 flex flex-col p-6 bg-card shadow rounded-2xl">
                                        <div class="flex items-center">
                                            <mat-icon class="icon-size-8 text-purple-500" [svgIcon]="'heroicons_solid:users'"></mat-icon>
                                            <div class="ml-4 text-secondary font-medium">Follower Growth</div>
                                        </div>
                                        <div class="mt-4 text-4xl font-bold">{{ ambassadorMetrics.vi_followed_by_count | number }}</div>
                                        <div class="mt-1 text-sm text-secondary">Total followers gained on the platform</div>
                                    </div>
                                </div>

                                <div class="grid grid-cols-1 sm:grid-cols-6 gap-6">
                                    <div class="sm:col-span-2 flex flex-col p-6 bg-card shadow rounded-2xl">
                                        <div class="flex items-center">
                                            <mat-icon class="icon-size-8 text-green-500" [svgIcon]="'heroicons_solid:building-storefront'"></mat-icon>
                                            <div class="ml-4 text-secondary font-medium">Partner Signups</div>
                                        </div>
                                        <div class="mt-4 text-4xl font-bold">{{ ambassadorMetrics.vi_affiliated_business_count | number }}</div>
                                        <div class="mt-1 text-sm text-secondary">New businesses via your link</div>
                                    </div>
                                    <div class="sm:col-span-2 flex flex-col p-6 bg-card shadow rounded-2xl">
                                        <div class="flex items-center">
                                            <mat-icon class="icon-size-8 text-orange-500" [svgIcon]="'heroicons_solid:user-plus'"></mat-icon>
                                            <div class="ml-4 text-secondary font-medium">Members Signups</div>
                                        </div>
                                        <div class="mt-4 text-4xl font-bold">{{ ambassadorMetrics.vi_affiliated_members_count | number }}</div>
                                        <div class="mt-1 text-sm text-secondary">New members via your link</div>
                                    </div>
                                    <div class="sm:col-span-2 flex flex-col p-6 bg-card shadow rounded-2xl">
                                        <div class="flex items-center">
                                            <mat-icon class="icon-size-8 text-yellow-500" [svgIcon]="'heroicons_solid:credit-card'"></mat-icon>
                                            <div class="ml-4 text-secondary font-medium">Affiliated Subscriptions</div>
                                        </div>
                                        <div class="mt-4 text-4xl font-bold">{{ ambassadorMetrics.vi_affiliated_subscriptions_count | number }}</div>
                                        <div class="mt-1 text-sm text-secondary">Affiliated users who have subscribed via your link</div>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </div>
                </ng-container>

            </div>
        </div>
    </div>

    <div *ngIf="userUiType === 2" class="flex flex-col flex-auto">
        <div class="relative flex flex-col flex-0 items-center justify-center p-6 sm:p-10 overflow-hidden bg-gray-50 dark:bg-gray-900">
            <div class="absolute inset-0 bg-gradient-to-br from-indigo-500 to-blue-600 opacity-10 dark:opacity-20"></div>
            <div class="relative z-10 flex flex-col items-center w-full max-w-screen-xl mx-auto">
                <div class="flex items-center">
                    <img class="w-40 h-20 object-contain" ngSrc="assets/images/altitude%20rewards/logo/ar-logo-no-slogan-2.png" alt="Logo" width="660" height="320">
                    <div class="ml-6 text-left">
                        <div class="text-4xl font-bold tracking-tight leading-none">
                            Hello, {{user.ds_firstname}}!
                        </div>
                        <div class="mt-1.5 text-lg text-secondary">
                            Welcome to your Business Dashboard.
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="flex-auto p-6 sm:p-10">
            <div class="w-full max-w-screen-xl mx-auto">

                <div class="mt-4">
                    <div class="text-2xl font-semibold tracking-tight">Your Properties & Quick Actions</div>

                    <div class="flex flex-col p-6 bg-card shadow rounded-2xl mt-4 mb-6 border border-gray-100 dark:border-gray-800">
                        <div class="flex items-start">
                            <div class="flex items-center justify-center w-12 h-12 rounded-full bg-indigo-100 text-indigo-600 dark:bg-indigo-900 dark:text-indigo-100 mr-6 shrink-0">
                                <mat-icon class="icon-size-6" [svgIcon]="'heroicons_outline:building-storefront'"></mat-icon>
                            </div>
                            <div class="flex flex-col">
                                <div class="text-xl font-semibold leading-tight text-primary">Manage Your Business Presence</div>
                                <div class="mt-2 text-secondary text-lg leading-relaxed">
                                    Keep your property profiles up to date and engaging. Use the quick actions below to manage your business details, upload high-quality images, and publish exclusive special offers to attract more customers.
                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="isInitializing" class="flex items-center justify-center py-8">
                        <mat-progress-spinner [diameter]="48" [mode]="'indeterminate'"></mat-progress-spinner>
                    </div>

                    <div *ngIf="!isInitializing" class="mt-6 bg-card shadow rounded-2xl overflow-hidden border border-gray-100 dark:border-gray-800">
                        <div class="overflow-x-auto">
                            <table class="w-full text-left border-collapse">
                                <thead>
                                <tr class="bg-gray-50 dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
                                    <th class="p-4 font-semibold text-secondary whitespace-nowrap">Property Name</th>
                                    <th class="p-4 font-semibold text-secondary text-right">Actions</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr *ngFor="let prop of myProperties" class="border-b border-gray-100 dark:border-gray-800 last:border-0 hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-colors">
                                    <td class="p-4 font-medium text-primary align-middle">
                                        {{prop.title}}
                                    </td>
                                    <td class="p-4 flex flex-wrap gap-2 justify-end">
                                        <button mat-flat-button color="primary" (click)="navigateToManagement('features', prop.queryParams.id_destination)">
                                            <mat-icon class="mr-2 icon-size-5" [svgIcon]="'heroicons_outline:building-office'"></mat-icon>
                                            Manage Business
                                        </button>
                                        <button mat-stroked-button (click)="navigateToManagement('addimages', prop.queryParams.id_destination)">
                                            <mat-icon class="mr-2 icon-size-5" [svgIcon]="'heroicons_outline:photo'"></mat-icon>
                                            Add Images
                                        </button>
                                        <button mat-stroked-button (click)="navigateToManagement('addoffers', prop.queryParams.id_destination)">
                                            <mat-icon class="mr-2 icon-size-5" [svgIcon]="'heroicons_outline:tag'"></mat-icon>
                                            Add Special Offers
                                        </button>
                                    </td>
                                </tr>
                                <tr *ngIf="myProperties.length === 0">
                                    <td colspan="2" class="p-8 text-center text-secondary">
                                        No properties found. Please verify your menu configuration.
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="userUiType === 3" class="flex flex-col flex-auto">
        <div class="p-6 sm:p-10 bg-card">
            <div class="w-full max-w-screen-xl mx-auto">
                <div class="text-4xl font-bold tracking-tight">Admin Dashboard</div>
                <div class="mt-1.5 text-lg text-secondary">Welcome back, {{user.ds_firstname}}.</div>
            </div>
        </div>

        <div class="flex-auto p-6 sm:p-10">
            <div class="w-full max-w-screen-xl mx-auto">
                <div class="flex flex-col items-center justify-center p-12 bg-card shadow rounded-2xl">
                    <mat-icon class="icon-size-24 text-gray-400" [svgIcon]="'heroicons_solid:wrench-screwdriver'"></mat-icon>
                    <div class="mt-6 text-2xl font-semibold">Dashboard Under Construction</div>
                    <div class="mt-2 text-center text-secondary max-w-md">
                        This administrative dashboard is currently being developed. Key platform metrics, user management tools, and system analytics will be available here soon.
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
